import { render, staticRenderFns } from "./PaymentChart.vue?vue&type=template&id=2b378901&"
import script from "./PaymentChart.vue?vue&type=script&lang=ts&"
export * from "./PaymentChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports